import React, { Suspense, lazy } from "react";
import { useReducedAnimations } from "../hooks/useReducedAnimations";

const BackgroundBeams = lazy(() =>
  import("./ui/background-beams").then((mod) => ({
    default: mod.BackgroundBeams,
  }))
);

const BackgroundBeamsLoader = () => {
  const reducedAnimations = useReducedAnimations();

  if (reducedAnimations) return null;

  return (
    <Suspense fallback={null}>
      <BackgroundBeams />
    </Suspense>
  );
};

export default BackgroundBeamsLoader;
